import {
  COLORMAP_QUEUE_CONGESTION,
  COLORMAP_QUEUE_CONGESTION_BLUE,
  COLORMAP_QUEUE_CONGESTION_BLUE_FOR_TEXT,
  COLORMAP_QUEUE_CONGESTION_FOR_TEXT,
  ColorGradient,
} from 'features/chart/colorMaps';
import { ts_to_minutes } from 'features/common/slotsUtils';
import {
  Feature,
  FeatureCollection,
  LineString,
  MultiLineString,
} from 'geojson';

export const nullCongestionColor = '#3A3A3A';
export const kQueueOutlineColor = '#d94910';

export enum TagmaState {
  CONGESTED = 'CONGESTED',
  QUEUED = 'QUEUED',
}

export type RouteQueueTagmaProperties = {
  arthropod_id: number;
  tagma_id: number;
  timestep_at_tz: string;
  state: string;
  agg_atypical_delay_min: number;
  agg_typical_traveltime_min: number;
  agg_geom_length_km: number;
  offset_start_km: number;
  offset_end_km: number;
};

export type RouteQueueSegmentLineProperties = {
  arthropod_id: number;
  tagma_id: number;
  timestep_at_tz: string;
  seq: number;
  osm_segment_id: string;
  geom_length_km: number;
  state: string;
  atypical_delay_min: number;
  typical_traveltime_min: number;
  freeflow_speed_kmph: number;
  average_speed_kmph: number;
  null_is_clogged: boolean;
  typical_speed_kmph: number;
  offset_start_km: number;
  offset_end_km: number;
};

export type RouteQueueTagma = Feature<
  LineString | MultiLineString,
  RouteQueueTagmaProperties | RouteQueueSegmentLineProperties
>;

export type RouteQueueSegment = Feature<
  LineString | MultiLineString,
  RouteQueueSegmentLineProperties
>;

export type RouteQueueData = {
  tagmas: FeatureCollection<
    LineString | MultiLineString,
    RouteQueueTagmaProperties
  >;
  segment_times: FeatureCollection<
    LineString | MultiLineString,
    RouteQueueSegmentLineProperties
  >;
};

export const get_queue_id = (d: RouteQueueTagma) => d.properties.arthropod_id;
export const get_timestamp = (d: RouteQueueTagma) =>
  d.properties.timestep_at_tz;
export const get_offset_start = (d: RouteQueueTagma) =>
  d.properties.offset_start_km;
export const get_offset_end = (d: RouteQueueTagma) =>
  d.properties.offset_end_km;
export const get_congestion = (d: RouteQueueSegment) => {
  if (d.properties.average_speed_kmph !== null) {
    return Math.min(
      d.properties.average_speed_kmph / d.properties.freeflow_speed_kmph,
      1.0,
    );
  }

  return null;
};
export const get_minute_offset = (d: RouteQueueTagma, targetDate: string) =>
  ts_to_minutes(get_timestamp(d), targetDate);

export function colorRampForColorStatus(
  isColorBlind,
  forText = false,
): ColorGradient {
  if (isColorBlind) {
    if (forText) {
      return COLORMAP_QUEUE_CONGESTION_BLUE_FOR_TEXT;
    } else {
      return COLORMAP_QUEUE_CONGESTION_BLUE;
    }
  } else if (forText) {
    return COLORMAP_QUEUE_CONGESTION_FOR_TEXT;
  } else {
    return COLORMAP_QUEUE_CONGESTION;
  }
}
